/** A large padding to simulate the infinite scrolling. */
export const SCROLL_PADDING = 2e6;

export const SPOTLIGHT_TARGET_Z_INDEX = 701;
